import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/models';
import { useLinkTo, useParams } from '../../hooks';
import { MOBILE_APP_START_ROUTE, PRO_TODAY_TAB_HOME } from '../../route-names';
import { getIsApp } from '../../modules/AppInfo';
import HomePage from './Home';

/**
 * This page is responsible for redirecting users to the appropriate landing page
 * from the root route (/, /m, /m/)
 */
const LandingRedirect = () => {
  const linkTo = useLinkTo();
  const params = useParams();
  const currentUser = useSelector<RootState, RootState['user']>(
    state => state.user,
    (left, right) => left?.userId === right?.userId,
  );

  if (currentUser?.providerId) {
    linkTo(PRO_TODAY_TAB_HOME, {
      providerId: currentUser.providerId,
      ...params,
    });
    return null;
  } if (getIsApp() && currentUser?.is_anon) {
    linkTo(MOBILE_APP_START_ROUTE, params);
    return null;
  }

  return <HomePage />;
};

export default LandingRedirect;
